import { environment } from '@/shared/enviroment/environment';
import { ApiService } from '@/shared/service/Apiservice';
import axios from 'axios';
import { ProductResponseDto, GetProductsParams } from '../dto/search.dto';

class SearchService {
  private apiRootServer = environment.api.apiRootServer;
  private __Apiservice: ApiService;

  constructor() {
    const axiosInstance = axios.create();
    this.__Apiservice = new ApiService(axiosInstance, this.apiRootServer);
  }

  async GetProdect(params: GetProductsParams = {}): Promise<ProductResponseDto> {
    const queryParams: Record<string, any> = {};

    // Add all parameters to query string
    if (params._id) queryParams._id = params._id;
    if (params.name) queryParams.name = params.name;
    if (params.slug) queryParams.slug = params.slug;
    if (params.category) queryParams.category = params.category;
    if (params.isActive !== undefined) queryParams.isActive = params.isActive;
    if (params.isFeatured !== undefined) queryParams.isFeatured = params.isFeatured;
    if (params.minPrice) queryParams.minPrice = params.minPrice;
    if (params.maxPrice) queryParams.maxPrice = params.maxPrice;
    if (params.search) queryParams.search = params.search;
    if (params.page) queryParams.page = params.page;
    if (params.limit) queryParams.limit = params.limit;
    if (params.variantTitle) queryParams.variantTitle = params.variantTitle;
    if (params.variantDescription) queryParams.variantDescription = params.variantDescription;
    
    // Add search options to query params
    if (params.searchInTitle !== undefined) queryParams.searchInTitle = params.searchInTitle;
    if (params.searchInDescription !== undefined) queryParams.searchInDescription = params.searchInDescription;
    if (params.searchInCategories !== undefined) queryParams.searchInCategories = params.searchInCategories;
    if (params.searchInTags !== undefined) queryParams.searchInTags = params.searchInTags;
    if (params.searchInSku !== undefined) queryParams.searchInSku = params.searchInSku;
    if (params.searchInSpecifications !== undefined) queryParams.searchInSpecifications = params.searchInSpecifications;
    if (params.searchInBrand !== undefined) queryParams.searchInBrand = params.searchInBrand;


    try {
      const response = await this.__Apiservice.getRequest<ProductResponseDto>(
        'products', 
        queryParams, 
        {
          apiRoot: this.apiRootServer,
        }
      );
      
      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Search products across multiple fields
   */
  async SearchProducts(
    searchTerm: string,
    page: number = 1,
    limit: number = 10,
    options: {
      searchInTitle?: boolean;
      searchInDescription?: boolean;
      searchInCategories?: boolean;
      searchInTags?: boolean;
      searchInSku?: boolean;
      searchInSpecifications?: boolean;
      searchInBrand?: boolean;
    } = {}
  ): Promise<ProductResponseDto> {
    if (!searchTerm || !searchTerm.trim()) {
      return {
        success: true,
        data: [],
        pagination: {
          total: 0,
          page: 1,
          limit: limit,
          totalPages: 0,
          hasNextPage: false,
          hasPreviousPage: false
        }
      };
    }

    // Default to searching in all fields if none specified
    const searchOptions = {
      searchInTitle: true,
      searchInDescription: true,
      searchInCategories: true,
      searchInTags: true,
      searchInSku: true,
      searchInSpecifications: true,
      searchInBrand: true,
      ...options
    };

    // Build search query parameters
    const searchParams: GetProductsParams = {
      page,
      limit,
      search: searchTerm.trim(),
      isActive: true,
      ...searchOptions
    };


    return this.GetProdect(searchParams);
  }
}

export default SearchService;
